// @flow

import axios from 'axios';
import config from '../../config';

const getClient = () =>
  axios.create({
    baseURL: config.disputes_api_url
    // NOTE: `Authorization` header and other parameters are inherited from
    // default client instance
  });

export const disputesAPI = getClient();
